import React from 'react';
import NewspaperIcon from '@mui/icons-material/Newspaper';

const NewsCard = ({ title, description, image, onReadMore }) => {
  // Clean HTML and truncate description
  const cleanDescription = React.useMemo(() => {
    if (!description) return 'Sin descripción';
  
    // Paso 1: Reemplazar saltos de párrafo y <br> por un espacio
    let replaced = description
      .replace(/<\/p>|<br\s*\/?>/gi, ' ')  // reemplaza </p> y <br> por espacio
      .replace(/<[^>]*>/g, ''); // elimina el resto de las etiquetas HTML
  
    // Paso 2: Decodificar entidades HTML como &nbsp;
    const decoded = new DOMParser().parseFromString(replaced, 'text/html').documentElement.textContent || '';
  
    // Paso 3: Eliminar espacios duplicados y saltos
    const cleaned = decoded.replace(/\s+/g, ' ').trim();
  
    // Paso 4: Truncar
    return cleaned.length > 150 ? `${cleaned.substring(0, 150)}...` : cleaned;
  }, [description]);
  
  

  return (
    <div className="bg-white/90 backdrop-blur-md rounded-xl overflow-hidden shadow-lg transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-xl flex flex-col h-full">
      <img
        src={image || 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80'}
        alt={title}
        className="h-[180px] w-full object-cover"
        loading="lazy"
      />
      <div className="p-5 flex-grow">
        <h3 className="text-xl font-semibold text-gray-800 mb-3 leading-snug">
          {title}
        </h3>
        <p className="text-gray-600 mb-4">
          {cleanDescription}
        </p>
      </div>
      <div className="px-5 pb-5">
      <button 
        onClick={onReadMore}
        className="w-full py-2 bg-[#C42251] text-white font-semibold rounded-lg shadow transition-all duration-300 hover:bg-[#DC3465] hover:-translate-y-1 hover:shadow-md"
      >
        Leer más
      </button>
      </div>
    </div>
  );
};

const NewsSection = ({ news, loading, error, onReadMore }) => {
  return (
    <div className="py-12 md:py-20 bg-gradient-to-b from-[#0488AF] to-[#09274A] relative rounded-2xl">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section Title */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-wide uppercase mb-2 relative inline-block">
            <NewspaperIcon className="text-white mr-2" fontSize="large" />
            Noticias Destacadas
            <span className="block w-16 h-1 bg-[#DC3465] mt-2 mx-auto rounded-full"></span>
          </h2>
        </div>

        {/* Content */}
        <div>
          {loading ? (
            <div className="flex justify-center py-8">
              <div className="w-16 h-16 rounded-full border-4 border-[#f9f9f9] border-t-transparent animate-spin"></div>
            </div>
          ) : error ? (
            <div className="flex justify-center py-8">
              <p className="text-white text-xl">{error}</p>
            </div>
          ) : news.length === 0 ? (
            <div className="flex justify-center py-8">
              <p className="text-white text-xl">No hay noticias disponibles</p>
            </div>
          ) : (
              <div
                className={`grid gap-6 ${
                  news.length === 1
                    ? 'grid-cols-1 place-items-center'
                    : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3'
                }`}
              >
              {news.map((newsItem) => (
                <div
                key={newsItem.id}
                className={`flex justify-center w-full ${
                  news.length === 1 ? 'max-w-sm' : ''
                }`}
              >
              
                <NewsCard
                      title={newsItem.title}
                    description={newsItem.description}
                    image={newsItem.image}
                    onReadMore={() => onReadMore(newsItem.id)}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(NewsSection);